// Version 4 (K29, 27.10.2026): eigene Menü und Seitentitel für einzelne Seiten. Adressen bleiben gleich.
export const V4_LABELS = {
    "/wissen/fachartikel": { de: "Blog", en: "[Blog]" },
    "/wissen/news-presse": { de: "Presse", en: "[Press]" },
};
export const v4Label = (path, k, fallback) => V4_LABELS[path]?.[k] || fallback;

// 29.10.2026: in Version 4 ausgeblendete Menüpunkte (Praxisbeispiele sind Teil des Blogs)
export const V4_HIDDEN = new Set(["/wissen/praxisbeispiele"]);
